import { c as _c } from "react/compiler-runtime";
import { useMap } from "react-leaflet";
import { useState, useEffect, useRef } from "react";
export default function useMapPan() {
  const $ = _c(7);
  const map = useMap();
  let t0;
  if ($[0] !== map) {
    t0 = map.getCenter();
    $[0] = map;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [pan, setPan] = useState(t0);
  let t1;
  if ($[2] !== map) {
    t1 = map.getCenter();
    $[2] = map;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const prevCenterRef = useRef(t1);
  let t2;
  let t3;
  if ($[4] !== map) {
    t2 = () => {
      const handleMoveEnd = () => {
        const newCenter = map.getCenter();
        const distance = newCenter.distanceTo(prevCenterRef.current);
        if (distance > 10) {
          prevCenterRef.current = newCenter;
          setPan(newCenter);
        }
      };
      map.on("moveend", handleMoveEnd);
      return () => {
        map.off("moveend", handleMoveEnd);
      };
    };
    t3 = [map];
    $[4] = map;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  return pan;
}